import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Typography
} from '@mui/material';
import { apiUrl } from "../../constants";
import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useNavigate } from 'react-router-dom';
import EditNoteIcon from '@mui/icons-material/EditNote';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useSelector } from 'react-redux';
import useCheckToken from '../../hooks/useCheckToken';
import useExchangeToken from "../../hooks/useExchangeToken";

const MySwal = withReactContent(Swal);

function MasterPlantList({ customers, ...rest }) {
  const exchangeToken = useExchangeToken();
  const navigate = useNavigate();
  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [deleteButton, setDeleteButton] = useState(false);
  const [deleteNumber, setdeleteNumber] = useState(0);
  const [idUser, setId] = useState();
  const [select, setSelect] = useState();
  const [error, setError] = useState(null);
  const [moduleQuery, setModuleQuery] = useState('');
  const [committedModule, setCommittedModule] = useState(''); 

  useCheckToken();
  const ac_token = useSelector(state => state.auth.access_token);

  useEffect(() => {
    const fetchMyAPI = async () => {
      try {
        await exchangeToken();
        const id = new URL(window.location.href).searchParams.get("id");
        const url = `${apiUrl.USER}${id}/`;
        await axios.get(url, { headers: { Authorization: `Bearer ${ac_token}` } });
      } catch (error) {
        console.error("Error fetching or exchanging token:", error);
        setError("Failed to fetch user data");
      }
    };
    fetchMyAPI();
  }, [ac_token, exchangeToken]);

  const norm = (v) => (v ?? '').toString().toLowerCase();
  const filteredCustomers = useMemo(() => {
    if (!committedModule) return customers;
    const q = norm(committedModule);
    return customers.filter(c => norm(c.module).includes(q));
  }, [customers, committedModule]);

  useEffect(() => {
    setSelectedCustomerIds([]);
    setDeleteButton(false);
    setdeleteNumber(0);
    setId([]);
    setPage(0);
  }, [committedModule]);

  const handleSelectAll = (event) => {
    let newSelectedCustomerIds;
    if (event.target.checked) {
      newSelectedCustomerIds = filteredCustomers.map((customer) => customer.id);
      setDeleteButton(true);
      setdeleteNumber(newSelectedCustomerIds.length);
      setId(newSelectedCustomerIds);
    } else {
      newSelectedCustomerIds = [];
      setDeleteButton(false);
      setId(newSelectedCustomerIds);
    }
    setSelectedCustomerIds(newSelectedCustomerIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedCustomerIds.indexOf(id);
    let newSelectedCustomerIds = [];
    if (selectedIndex === -1) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedCustomerIds, id);
      setDeleteButton(true);
      setdeleteNumber(newSelectedCustomerIds.length);
      setId(newSelectedCustomerIds);
    } else if (selectedIndex === 0) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedCustomerIds.slice(1));
      if (newSelectedCustomerIds.length === 0) {
        setDeleteButton(false);
      } else {
        setDeleteButton(true);
        setId();
        setdeleteNumber(newSelectedCustomerIds.length);
      }
    } else if (selectedIndex === selectedCustomerIds.length - 1) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedCustomerIds.slice(0, -1));
      setDeleteButton(true);
      setId(newSelectedCustomerIds);
      setdeleteNumber(newSelectedCustomerIds.length);
    } else if (selectedIndex > 0) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds.slice(0, selectedIndex),
        selectedCustomerIds.slice(selectedIndex + 1)
      );
      setDeleteButton(true);
      setId();
      setdeleteNumber(newSelectedCustomerIds.length);
    }
    setSelectedCustomerIds(newSelectedCustomerIds);
  };

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleDelete = async () => {
    MySwal.fire({
      title: 'Are you sure to delete?',
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      didOpen: () => {
        const confirmButton = document.querySelector('.swal2-confirm');
        const cancelButton = document.querySelector('.swal2-cancel');
        if (confirmButton) { confirmButton.style.fontFamily = 'CPF_Imm_Sook'; confirmButton.style.fontSize = '20px'; }
        if (cancelButton) { cancelButton.style.fontFamily = 'CPF_Imm_Sook'; cancelButton.style.fontSize = '20px'; }
      }
    }).then(async (result) => {
      if (result.value) {
        try {
          let resp;
          for (let i = 0; i < selectedCustomerIds.length; i++) {
            const chack_on_delete = select === undefined ? '' : select.check_on;
            resp = await axios.delete(`${apiUrl.EDIT_MASTER_PLANT}delete/${chack_on_delete}/`, {
              headers: { Authorization: `Bearer ${ac_token}` }
            });
          }
          if (resp?.status === 200) {
            MySwal.fire({ title: 'Done!', text: 'Successfully deleted master plant.', icon: 'success', confirmButtonText: 'Ok,Got it!' })
              .then(() => window.location.reload(true));
          } else {
            MySwal.fire({ title: 'Error!', text: 'Can not delete this master plant.', icon: 'error', confirmButtonText: 'Ok,Got it!' });
          }
        } catch (error) {
          console.log('error', error);
        }
      }
    });
  };

  const doSearch = () => setCommittedModule(moduleQuery.trim());
  const clearSearch = () => { setModuleQuery(''); setCommittedModule(''); };
  const handleKeyDown = (e) => { if (e.key === 'Enter') doSearch(); };

  return (
    <Card {...rest}>
      <Box
        sx={{ width: '100%', backgroundColor: 'pink', p: 1 }}
        style={{ display: deleteButton ? 'block' : 'none' }}
      >
        <Button style={{ color: 'white', backgroundColor: 'red' }} onClick={handleDelete}>
          Delete
        </Button>
        <Button style={{ color: 'red' }}>
          &nbsp;&nbsp;{deleteNumber} rows Selected
        </Button>
      </Box>

      <Box sx={{ p: 2, display: 'flex', gap: 1, alignItems: 'center' }}>
        <TextField
          variant="outlined"
          size="small"
          label="ค้นหา Module"
          placeholder="ชื่อ Module"
          value={moduleQuery}
          onChange={(e) => setModuleQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          sx={{
            "& .MuiOutlinedInput-input": {
              color: "#000000",
              fontFamily: 'CPF_Imm_Sook',
              fontSize: 18
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: moduleQuery ? (
              <InputAdornment position="end">
                <IconButton aria-label="clear search" size="small" onClick={clearSearch}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ) : null
          }}
          style={{ minWidth: 320 }}
        />
        <Button
          variant="contained"
          color="primary"
          startIcon={<SearchIcon />}
          onClick={doSearch}
        >
          ค้นหา
        </Button>
        {committedModule && (
          <Typography>
            แสดงผลสำหรับคำค้น: <b>{committedModule}</b> ({filteredCustomers.length} รายการ)
          </Typography>
        )}
      </Box>

      <PerfectScrollbar>
        <Box sx={{ width: '100%', height: "680px", display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
            <Table stickyHeader aria-labelledby="tableTitle">
              <TableHead>
                <TableRow>
                  <TableCell
                    padding="checkbox"
                    sx={{ minWidth: 60, backgroundColor: '#f5f5f5', position: 'sticky', top: 0, zIndex: 2 }}
                  >
                    <Checkbox
                      checked={filteredCustomers.length > 0 && selectedCustomerIds.length === filteredCustomers.length}
                      color="default"
                      indeterminate={selectedCustomerIds.length > 0 && selectedCustomerIds.length < filteredCustomers.length}
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  {["Bu", "Plant", "Factory", "Line", "Module", "Status", "Action"].map((label, idx) => (
                    <TableCell
                      key={idx}
                      sx={{
                        backgroundColor: '#f5f5f5',
                        color: '#000000',
                        fontSize: 16,
                        fontWeight: 'bold',
                        minWidth: 150,
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredCustomers.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      {committedModule ? 'ไม่พบข้อมูลที่ตรงกับคำค้น' : 'No data found'}
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredCustomers
                    .slice(page * limit, limit === -1 ? filteredCustomers.length : page * limit + limit)
                    .map((customer) => (
                      <TableRow
                        hover
                        key={customer.id}
                        selected={selectedCustomerIds.includes(customer.id)}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={selectedCustomerIds.includes(customer.id)}
                            onChange={(event) => handleSelectOne(event, customer.id)}
                            onClick={() => setSelect({ check_on: customer.check_on })}
                          />
                        </TableCell>
                        <TableCell sx={{ fontSize: 14 }}>{customer.bu}</TableCell>
                        <TableCell sx={{ fontSize: 14 }}>{customer.plant_id}</TableCell>
                        <TableCell sx={{ fontSize: 14 }}>{customer.factory}</TableCell>
                        <TableCell sx={{ fontSize: 14 }}>{customer.line}</TableCell>
                        <TableCell sx={{ fontSize: 14 }}>{customer.module}</TableCell>
                        <TableCell sx={{ fontSize: 14 }}>{customer.status}</TableCell>
                        <TableCell>
                          <EditNoteIcon
                            onClick={() => navigate(`/setting/edit-master-plant?id=${customer.id}`, { replace: true })}
                            sx={{ fontSize: 22, cursor: 'pointer' }}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </Box>
        </Box>
      </PerfectScrollbar>

      <TablePagination
        component="div"
        count={filteredCustomers.length}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
      />
    </Card>
  );
}

MasterPlantList.propTypes = {
  customers: PropTypes.array.isRequired
};

export default MasterPlantList;
